import BaseService from "@/services/BaseService";
import Organization from "@/types/Organization";

export default class OrganizationService extends BaseService {
    static async getOrganizations() {
        return await this.perform<Organization[]>({
            url: "/portal/organizations",
            method: "GET",
            auth: true
        });
    }

    static async addOrganization(organization: Organization) {
        return await this.perform<Organization>({
            url: "/portal/organizations",
            method: "POST",
            auth: true,
            body: {
                organizationId: organization.organizationId,
                name: organization.name,
                wlextHost: organization.wlextHost,
                wlextOrganizationId: organization.wlextOrganizationId,
                logo: organization.logo,
                customInvitationText: organization.customInvitationText,
                categories: organization.categories,
                isActive: true
            }
        });
    }

    static async updateOrganization(organization: Organization) {
        return await this.perform<Organization>({
            url: "/portal/organizations/" + organization.id,
            method: "PUT",
            auth: true,
            body: {
                organizationId: organization.organizationId,
                name: organization.name,
                wlextHost: organization.wlextHost,
                wlextOrganizationId: organization.wlextOrganizationId,
                logo: organization.logo,
                customInvitationText: organization.customInvitationText,
                categories: organization.categories,
                isActive: organization.isActive
            }
        });
    }

    static async deleteOrganization(organization: Organization) {
        return await this.perform<Organization>({
            url: "/portal/organizations/" + organization.id,
            method: "DELETE",
            auth: true
        });
    }
}